import React from 'react';
import { Col, Row } from 'antd';
import style from './index.scss';
import BreadCrumb from '../../../components/BreadCrumb';
import SegmentsListing from './segmentsListing';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import {
  getCustomerType,
  postCustomerType,
  putCustomerType,
  deleteCustomerType
} from '../../../redux/actions/ns/runInstance';
import Wait4Me from '../../../components/Wait4Me';

export const Segments = ({
  apiActions,
  customerTypeList,
  isLoading,
  authentication
}) => {
  return (
    <Row>
      <Col span={24}>
        <div className={style.wrapper}>
          <div className={style.head}>
            <BreadCrumb crumbs={[{ label: 'Segments' }]} />
            <div className={style.head_content}>
              <h4>Segments</h4>
            </div>
          </div>
          {customerTypeList?.data?.length === 0 || undefined ? (
            <div className={style.loadingWrapper}>
              <Wait4Me />
            </div>
          ) : (
            <SegmentsListing
              apiActions={apiActions}
              customerTypeList={customerTypeList}
              isLoading={isLoading}
              authentication={authentication}
            />
          )}
        </div>
      </Col>
    </Row>
  );
};

function mapStateToProps({ nsRunInstanceConfig, authentication }) {
  return {
    customerTypeList: nsRunInstanceConfig.customerTypeList || {},
    isLoading:
      nsRunInstanceConfig.customerTypeList?.isLoading ||
      nsRunInstanceConfig.deleteCustomerTypeList?.isLoading ||
      nsRunInstanceConfig.postCustomerTypeList?.isLoading ||
      nsRunInstanceConfig.putCustomerTypeList?.isLoading,
    authentication: authentication
  };
}

function mapDispatchToProps(dispatch) {
  return {
    apiActions: bindActionCreators(
      {
        navigateTo: (path) => push(path),
        getCustomerType,
        postCustomerType,
        putCustomerType,
        deleteCustomerType,
        dispatch
      },
      dispatch
    ),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Segments);
